import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import ListChannels from "../channelManagement/ListChannels";

import { ChannelDetail } from "../channelManagement/ChannelDetail";
import ChannelHistory from "../channelManagement/ChannelHistory";
import { useNavigationBar } from "../../context/NavigationContext";
import UserFeedbackLayout from "./UserFeedbackLayout";
import ListFeedback from "./ListFeedback";
import FeedbackDetail from "./feedbackDetails";
//list feedback old md file si previos version of Feedback list

const UserFeedback = () => {
  const location = useLocation();
  const { backgroundLocation } = useNavigationBar();
  //const state = location.state as { backgroundLocation?: Location };
  const oldLocation = backgroundLocation?.pathname.includes("dashboard/UserFeedback") ? backgroundLocation : location;

  return (
    <>
      {/* <Routes location={background || location}> */}
      <Routes location={oldLocation}>
        <Route path="/list" element={<ListFeedback />} />
        <Route element={<UserFeedbackLayout />}>
          <Route path="/list/:type/:id" element={<FeedbackDetail />} />
        </Route>
        <Route path="/" element={<Navigate replace to="./list" />} />
      </Routes>
      {backgroundLocation && (
        <Routes>
          <Route element={<UserFeedbackLayout />}>
            <Route path="/list/:type/:id" element={<FeedbackDetail />} />
          </Route>
        </Routes>
      )}
    </>
  );
};

export default UserFeedback;
